// extracted by mini-css-extract-plugin
export default {"header":"BomTable_header__x6Wro","body":"BomTable_body__PBlj9"};